<template>
  <div id="app">
    <NavBar/>
    <NotificationContainer/>
    <router-view/>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import NotificationContainer from "./components/NotificationContainer.vue";

export default {
  name: "App",
  components: { NavBar, NotificationContainer }
};
</script>

<style>
#app {
  box-sizing: border-box;
  width: 600px;
  padding: 0 20px 20px;
  margin: 0 auto;
  color: whitesmoke;
}
html,
body {
  background-image: linear-gradient(
    to bottom right,
    #362a34,
    #6b5056,
    #7b595a,
    #7c5245
  );
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: whitesmoke;
  font-family: "Poppins", sans-serif;
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
img {
  image-orientation: from-image;
}
.navBarBuffer {
  margin-top: 120px;
}
</style>
